import { axiosClient } from "./apiClient";

//============================ user api start=================================//

export function signup(data) {
    return axiosClient.post('/lea-training/v1/user/auth/signup-user', data)
}

export function login(data) {
    return axiosClient.post('/lea-training/v1/user/auth/login-user', data)
}

export function editProfile(data) {
    return axiosClient.post('/lea-training/v1/user/auth/update-user', data)
}

export function completeProfile(data) {
    return axiosClient.post('/lea-training/v1/user/auth/complete-profile', data)
}

export function countryListing(data) {
    return axiosClient.post('/lea-training/v1/user/auth/country-list', data)
}

export function cityListing(data) {
    return axiosClient.post('/lea-training/v1/user/auth/city-list', data)
}

export function languageListing(data) {
    return axiosClient.post('/lea-training/v1/user/auth/language-list', data)
}

export function changePassword(data) {
    return axiosClient.post('/lea-training/v1/user/auth/change-password', data)
}

export function signout() {
    return axiosClient.post('/lea-training/v1/user/auth/logout-user')
}

export function deleteProfile(data) {
    return axiosClient.post('/lea-training/v1/user/auth/delete-user', data)
}

export function forgetPassword(data) {
    return axiosClient.post('/lea-training/v1/user/auth/forget-password', data)
}

export function resendNewOtp(data) {
    return axiosClient.post('/lea-training/v1/user/auth/resend-otp', data)
}

export function otpVerification(data) {
    return axiosClient.post('/lea-training/v1/user/auth/verify-otp', data)
}

export function setPassword(data) {
    return axiosClient.post('/lea-training/v1/user/auth/create-new-password', data)
}

export function contactUs(data) {
    return axiosClient.post('/lea-training/v1/user/auth/add-contact-us', data)
}

export function turnOnOffNotification(data) {
    return axiosClient.post('/lea-training/v1/user/notification/onoff-notification', data)
}

//============================ user api end=================================//

//============================ course module api start=================================//

export function courseListing(data) {
    return axiosClient.post('/lea-training/v1/user/home/course-list', data)
}

export function homeCourseListing(data) {
    return axiosClient.post('/lea-training/v1/user/home/home-course-list', data)
}

export function categoryList(data){
    return axiosClient.post('/lea-training/v1/user/home/category-list', data)
}

export function userEnrolledCourse(data) {
    return axiosClient.post('/lea-training/v1/user/home/user-course-list', data)
}

export function bookMarkCourse(data) {
    return axiosClient.post('/lea-training/v1/user/home/add-delete-favorite-course', data)
}

export function courseLesson(data) {
    return axiosClient.post('/lea-training/v1/user/home/lession-list', data)
}

export function courseRatingReview(data) {
    return axiosClient.post('/lea-training/v1/user/home/course-review-list', data)
}

export function addCourseReview(data) {
    return axiosClient.post('/lea-training/v1/user/home/add-course-review', data)
}

export function addUpdateLessonDetails(data) {
    return axiosClient.post('/lea-training/v1/user/home/add-user-lession-details',data)
}

export function favCourses(data) {
    return axiosClient.post('/lea-training/v1/user/home/user-favorite-course-list', data)
}

export function addToCart(data) {
    return axiosClient.post('/lea-training/v1/user/cart-payment/add-to-cart',data)
}

export function deleteCartCourse(data) {
    return axiosClient.post('/lea-training/v1/user/cart-payment/delete-cart-course',data)
}

export function myCartList(data) {
    return axiosClient.post('/lea-training/v1/user/cart-payment/my-cart-list',data)
}

export function applyDiscountCode(data) {
    return axiosClient.post('/lea-training/v1/user/cart-payment/apply-discount-code',data)
}

export function homeCount() {
    return axiosClient.post('/lea-training/v1/user/home/home-count')
}

//============================ course module api end=================================//

//============================ blog module api start=================================//

export function blogList(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/blog-list',data)
}

//============================ blog module api end=================================//


//============================ payment module api start=================================//

export function createOrder(data) {
    return axiosClient.post('/lea-training/v1/user/cart-payment/create-order',data)
}

export function placeOrder(data) {
    return axiosClient.post('/lea-training/v1/user/cart-payment/place-order',data)
}

//============================ payment module api end=================================//


//============================ cms module api start=================================//

export function cmsList(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/cms-list',data)
}

export function faqList(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/faq-list',data)
}

//============================ cms module api end=================================//


//============================ other module api start=================================//

export function communityForumList(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/community-forum-list', data)
}

export function communityForumAnswerList(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/community-forum-answer-list', data)
}

export function addCommunityForumAnswer(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/add-coomunity-forum-answer', data)
}

export function addCommunityForum(data) {
    return axiosClient.post('/lea-training/v1/user/community-forum/add-coomunity-forum', data)
}

//============================ other module api end=================================//

//============================ test module api start=================================//

export function startTest(data) {
    return axiosClient.post('/lea-training/v1/user/test/random-test-list', data)
}

export function testComplete(data) {
    return axiosClient.post('/lea-training/v1/user/test/user-attempt-test', data)
}

export function downloadCertificate(data) {
    return axiosClient.post('/lea-training/v1/user/test/download-certificate', data)
}

//============================ test module api end=================================//

//============================ complaint feedback api start=================================//

export function complaintFeedback(data) {
    return axiosClient.post('/lea-training/v1/user/home/add-complaint-feedback', data)
}

//============================ complaint feedback api end=================================//

//============================ animated videos api start=================================//

export function animatedVideosList(data) {
    return axiosClient.post('/lea-training/v1/user/animated-video/animated-video-list', data)
}

//============================ animated videos api end=================================//

//============================ trainer rating review api start=================================//

export function trainerRatingReview(data) {
    return axiosClient.post('/lea-training/v1/user/home/trainer-review-list', data)
}

export function addTrainerRatingReview(data) {
    return axiosClient.post('/lea-training/v1/user/home/add-trainer-review', data)
}

//============================ trainer rating review api end=================================//

//============================ chat module api start=================================//

export function recentChatList(data) {
    return axiosClient.post('/lea-training/v1/chat/recent_chat_list', data)
}

export function personalChatList(data) {
    return axiosClient.post('/lea-training/v1/chat/personal_chat_list', data)
}

export function notificationListing(data) {
    return axiosClient.post('/lea-training/v1/user/notification/notification-list', data)
}

export function trendingCourseList(data) {
    return axiosClient.post('/lea-training/v1/user/home/trending-course-list', data)
}

export function readNotification() {
    return axiosClient.post('/lea-training/v1/user/notification/read-notification')
}

export function verifyCerti(data) {
    return axiosClient.post(`/lea-training/v1/user/test/verify-certificate`,data);
}

export function uploadS3(data) {
    return axiosClient.post(`/lea-training/v1/s3-client/upload-image`,data);
}

export function checkUserExist(data) {
    return axiosClient.post('/lea-training/v1/user/auth/check-user-exist', data);
}

export function buyCourseApp(data) {
    return axiosClient.post('/lea-training/v1/user/auth/buy-course-app', data);
}